var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container income-admin-page" },
    [
      _c(
        "div",
        { staticClass: "page-heading" },
        [
          _vm._m(0),
          _vm.activeTab === "opportunities"
            ? _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    icon: "el-icon-plus",
                    disabled: _vm.featureDisabled,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.openEditor()
                    },
                  },
                },
                [_vm._v(" 新增方案 ")]
              )
            : _vm.activeTab === "earnings"
            ? _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    icon: "el-icon-plus",
                    disabled: _vm.featureDisabled,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.openEarningEditor()
                    },
                  },
                },
                [_vm._v(" 新增收益 ")]
              )
            : _vm._e(),
        ],
        1
      ),
      _c("el-alert", {
        staticClass: "permission-alert",
        attrs: {
          title:
            "本頁僅 ITA-DEV 與 ITA-ADMIN 可使用；請領僅變更 Mock 狀態，不取得銀行資料、不連接金流、不執行撥款。",
          type: "warning",
          closable: false,
          "show-icon": "",
        },
      }),
      _vm.featureDisabled
        ? _c("el-alert", {
            staticClass: "permission-alert",
            attrs: {
              type: "warning",
              title: "專區已關閉",
              description:
                "領隊導遊專區目前已關閉，新增、狀態變更與請領處理等寫操作已停用；如需開放，請聯絡系統管理員。",
              closable: false,
              "show-icon": "",
            },
          })
        : _vm._e(),
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.onTabChange },
          model: {
            value: _vm.activeTab,
            callback: function ($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "方案管理", name: "opportunities" } },
            [
              _c(
                "el-card",
                { staticClass: "filter-card", attrs: { shadow: "never" } },
                [
                  _c(
                    "el-form",
                    {
                      attrs: { inline: true, model: _vm.opportunityQuery },
                      nativeOn: {
                        submit: function ($event) {
                          $event.preventDefault()
                        },
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "關鍵字" } },
                        [
                          _c("el-input", {
                            attrs: {
                              clearable: "",
                              maxlength: "100",
                              placeholder: "標題或合作單位",
                            },
                            nativeOn: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.searchOpportunities($event)
                              },
                            },
                            model: {
                              value: _vm.opportunityQuery.keyword,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.opportunityQuery,
                                  "keyword",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "opportunityQuery.keyword",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "狀態" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { clearable: "", placeholder: "全部" },
                              model: {
                                value: _vm.opportunityQuery.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.opportunityQuery, "status", $$v)
                                },
                                expression: "opportunityQuery.status",
                              },
                            },
                            _vm._l(
                              _vm.opportunityStatusOptions,
                              function (option) {
                                return _c("el-option", {
                                  key: option.value,
                                  attrs: {
                                    label: option.label,
                                    value: option.value,
                                  },
                                })
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                icon: "el-icon-search",
                                loading: _vm.opportunityLoading,
                              },
                              on: { click: _vm.searchOpportunities },
                            },
                            [_vm._v(" 查詢 ")]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                icon: "el-icon-refresh",
                                disabled: _vm.opportunityLoading,
                              },
                              on: { click: _vm.resetOpportunities },
                            },
                            [_vm._v(" 重設 ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.opportunityError
                ? _c("el-alert", {
                    staticClass: "load-alert",
                    attrs: {
                      type: "error",
                      title: _vm.opportunityError,
                      closable: false,
                      "show-icon": "",
                    },
                  })
                : _vm._e(),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.opportunityLoading,
                      expression: "opportunityLoading",
                    },
                  ],
                  attrs: {
                    data: _vm.opportunities,
                    border: "",
                    stripe: "",
                    "empty-text": "尚無額外收入方案",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "title",
                      label: "標題",
                      "min-width": "220",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "partnerName",
                      label: "合作單位",
                      "min-width": "150",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "category", label: "分類", width: "110" },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "名額", width: "85", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  scope.row.remainingQuota == null
                                    ? "不限"
                                    : scope.row.remainingQuota
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "applicationCount",
                      label: "申請",
                      width: "75",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "推薦", width: "105", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-switch", {
                              attrs: {
                                value: scope.row.isRecommended === true,
                                disabled:
                                  _vm.recommendationSavingId === scope.row.id ||
                                  _vm.featureDisabled,
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.updateRecommendation(
                                    scope.row,
                                    $event
                                  )
                                },
                              },
                            }),
                            scope.row.isRecommended
                              ? _c("small", { staticClass: "sort-label" }, [
                                  _vm._v(
                                    " #" + _vm._s(scope.row.recommendSort) + " "
                                  ),
                                ])
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "狀態", width: "90", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  type: _vm.statusTagType(scope.row.status),
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.opportunityStatusLabel(
                                        scope.row.status
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "操作",
                      width: "390",
                      align: "center",
                      fixed: "right",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: { size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.previewOpportunity(scope.row)
                                  },
                                },
                              },
                              [_vm._v("預覽")]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  size: "mini",
                                  disabled: _vm.featureDisabled,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.openEditor(scope.row)
                                  },
                                },
                              },
                              [_vm._v(" 編輯 ")]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  size: "mini",
                                  disabled: _vm.featureDisabled,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.copyOpportunity(scope.row)
                                  },
                                },
                              },
                              [_vm._v(" 複製 ")]
                            ),
                            ["draft", "unpublished"].includes(scope.row.status)
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      size: "mini",
                                      type: "success",
                                      disabled: _vm.featureDisabled,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.changeOpportunityStatus(
                                          scope.row,
                                          "published"
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(" 發布 ")]
                                )
                              : _vm._e(),
                            scope.row.status === "published"
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      size: "mini",
                                      type: "warning",
                                      disabled: _vm.featureDisabled,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.changeOpportunityStatus(
                                          scope.row,
                                          "unpublished"
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(" 下架 ")]
                                )
                              : _vm._e(),
                            _c(
                              "el-dropdown",
                              {
                                attrs: { trigger: "click" },
                                on: {
                                  command: function ($event) {
                                    return _vm.handleOpportunityCommand(
                                      $event,
                                      scope.row
                                    )
                                  },
                                },
                              },
                              [
                                _c("el-button", { attrs: { size: "mini" } }, [
                                  _vm._v("更多"),
                                  _c("i", {
                                    staticClass:
                                      "el-icon-arrow-down el-icon--right",
                                  }),
                                ]),
                                _c(
                                  "el-dropdown-menu",
                                  {
                                    attrs: { slot: "dropdown" },
                                    slot: "dropdown",
                                  },
                                  [
                                    _c(
                                      "el-dropdown-item",
                                      { attrs: { command: "applications" } },
                                      [_vm._v("申請管理")]
                                    ),
                                    _c(
                                      "el-dropdown-item",
                                      {
                                        attrs: {
                                          command: "close",
                                          disabled:
                                            scope.row.status === "closed" ||
                                            _vm.featureDisabled,
                                        },
                                      },
                                      [_vm._v(" 結束方案 ")]
                                    ),
                                    _c(
                                      "el-dropdown-item",
                                      {
                                        attrs: {
                                          command: "delete",
                                          divided: "",
                                          disabled: _vm.featureDisabled,
                                        },
                                      },
                                      [_vm._v(" 刪除方案 ")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c("pagination", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.opportunityTotal > 0,
                    expression: "opportunityTotal > 0",
                  },
                ],
                attrs: {
                  total: _vm.opportunityTotal,
                  page: _vm.opportunityQuery.page,
                  limit: _vm.opportunityQuery.limit,
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(_vm.opportunityQuery, "page", $event)
                  },
                  "update:limit": function ($event) {
                    return _vm.$set(_vm.opportunityQuery, "limit", $event)
                  },
                  pagination: _vm.fetchOpportunities,
                },
              }),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "申請管理", name: "applications" } },
            [
              _c(
                "el-card",
                { staticClass: "filter-card", attrs: { shadow: "never" } },
                [
                  _c(
                    "el-form",
                    { attrs: { inline: true, model: _vm.applicationQuery } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "方案" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "opportunity-selector",
                              attrs: {
                                filterable: "",
                                placeholder: "請選擇方案",
                              },
                              on: { change: _vm.searchApplications },
                              model: {
                                value: _vm.selectedOpportunityId,
                                callback: function ($$v) {
                                  _vm.selectedOpportunityId = $$v
                                },
                                expression: "selectedOpportunityId",
                              },
                            },
                            _vm._l(_vm.opportunityOptions, function (option) {
                              return _c("el-option", {
                                key: option.id,
                                attrs: {
                                  label:
                                    option.title + "｜" + option.partnerName,
                                  value: option.id,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "狀態" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { clearable: "", placeholder: "全部" },
                              on: { change: _vm.searchApplications },
                              model: {
                                value: _vm.applicationQuery.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.applicationQuery, "status", $$v)
                                },
                                expression: "applicationQuery.status",
                              },
                            },
                            _vm._l(
                              _vm.applicationStatusOptions,
                              function (option) {
                                return _c("el-option", {
                                  key: option.value,
                                  attrs: {
                                    label: option.label,
                                    value: option.value,
                                  },
                                })
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.opportunityOptionsError
                    ? _c(
                        "div",
                        { staticClass: "selector-load-error" },
                        [
                          _c("el-alert", {
                            attrs: {
                              type: "error",
                              title: _vm.opportunityOptionsError,
                              closable: false,
                              "show-icon": "",
                            },
                          }),
                          _vm.opportunityOptionsRetryable
                            ? _c(
                                "el-button",
                                {
                                  attrs: { size: "mini" },
                                  on: { click: _vm.retryOpportunityOptions },
                                },
                                [_vm._v(" 重新載入方案 ")]
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm.applicationError
                ? _c("el-alert", {
                    staticClass: "load-alert",
                    attrs: {
                      type: "error",
                      title: _vm.applicationError,
                      closable: false,
                      "show-icon": "",
                    },
                  })
                : _vm._e(),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.applicationLoading,
                      expression: "applicationLoading",
                    },
                  ],
                  attrs: {
                    data: _vm.applications,
                    border: "",
                    stripe: "",
                    "empty-text": "請選擇方案，或目前尚無正式申請",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "applicantName",
                      label: "姓名",
                      "min-width": "110",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "eligibleRole", label: "身分", width: "85" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              _vm._s(
                                _vm.eligibleRoleLabel(scope.row.eligibleRole)
                              )
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "contact",
                      label: "聯絡方式",
                      "min-width": "130",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "summary",
                      label: "申請摘要",
                      "min-width": "230",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "submittedAt",
                      label: "申請時間",
                      width: "170",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "狀態", width: "95" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  type: _vm.applicationStatusTagType(
                                    scope.row.status
                                  ),
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.applicationStatusLabel(
                                        scope.row.status
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "操作",
                      width: "310",
                      align: "center",
                      fixed: "right",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: { size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.showApplication(scope.row)
                                  },
                                },
                              },
                              [_vm._v("詳情")]
                            ),
                            ["submitted", "reviewing"].includes(
                              scope.row.status
                            )
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      size: "mini",
                                      disabled: _vm.featureDisabled,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.changeApplicationStatus(
                                          scope.row,
                                          "reviewing"
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(" 審核中 ")]
                                )
                              : _vm._e(),
                            ["submitted", "reviewing"].includes(
                              scope.row.status
                            )
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      size: "mini",
                                      type: "success",
                                      disabled: _vm.featureDisabled,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.changeApplicationStatus(
                                          scope.row,
                                          "approved"
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(" 核准 ")]
                                )
                              : _vm._e(),
                            ["submitted", "reviewing"].includes(
                              scope.row.status
                            )
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      size: "mini",
                                      type: "danger",
                                      disabled: _vm.featureDisabled,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.changeApplicationStatus(
                                          scope.row,
                                          "rejected"
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(" 拒絕 ")]
                                )
                              : _vm._e(),
                            scope.row.status === "approved"
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      size: "mini",
                                      type: "primary",
                                      disabled: _vm.featureDisabled,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.openEarningEditor(
                                          null,
                                          scope.row
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(" 建立收益 ")]
                                )
                              : _vm._e(),
                            ["submitted", "reviewing", "approved"].includes(
                              scope.row.status
                            )
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      size: "mini",
                                      type: "warning",
                                      disabled: _vm.featureDisabled,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.changeApplicationStatus(
                                          scope.row,
                                          "cancelled"
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(" 取消 ")]
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c("pagination", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.applicationTotal > 0,
                    expression: "applicationTotal > 0",
                  },
                ],
                attrs: {
                  total: _vm.applicationTotal,
                  page: _vm.applicationQuery.page,
                  limit: _vm.applicationQuery.limit,
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(_vm.applicationQuery, "page", $event)
                  },
                  "update:limit": function ($event) {
                    return _vm.$set(_vm.applicationQuery, "limit", $event)
                  },
                  pagination: _vm.fetchApplications,
                },
              }),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "收益與 Mock 請領", name: "earnings" } },
            [
              _c(
                "el-card",
                { staticClass: "filter-card", attrs: { shadow: "never" } },
                [
                  _c(
                    "el-form",
                    {
                      attrs: { inline: true, model: _vm.earningQuery },
                      nativeOn: {
                        submit: function ($event) {
                          $event.preventDefault()
                        },
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "關鍵字" } },
                        [
                          _c("el-input", {
                            attrs: {
                              clearable: "",
                              maxlength: "100",
                              placeholder: "會員、方案或收益標題",
                            },
                            nativeOn: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.searchEarnings($event)
                              },
                            },
                            model: {
                              value: _vm.earningQuery.keyword,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.earningQuery,
                                  "keyword",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "earningQuery.keyword",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "收益狀態" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { clearable: "", placeholder: "全部" },
                              model: {
                                value: _vm.earningQuery.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.earningQuery, "status", $$v)
                                },
                                expression: "earningQuery.status",
                              },
                            },
                            _vm._l(_vm.earningStatusOptions, function (option) {
                              return _c("el-option", {
                                key: option.value,
                                attrs: {
                                  label: option.label,
                                  value: option.value,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Mock 請領狀態" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { clearable: "", placeholder: "全部" },
                              model: {
                                value: _vm.earningQuery.claimStatus,
                                callback: function ($$v) {
                                  _vm.$set(_vm.earningQuery, "claimStatus", $$v)
                                },
                                expression: "earningQuery.claimStatus",
                              },
                            },
                            _vm._l(_vm.claimStatusOptions, function (option) {
                              return _c("el-option", {
                                key: option.value,
                                attrs: {
                                  label: option.label,
                                  value: option.value,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                loading: _vm.earningLoading,
                              },
                              on: { click: _vm.searchEarnings },
                            },
                            [_vm._v(" 查詢 ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.earningError
                ? _c("el-alert", {
                    staticClass: "load-alert",
                    attrs: {
                      type: "error",
                      title: _vm.earningError,
                      closable: false,
                      "show-icon": "",
                    },
                  })
                : _vm._e(),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.earningLoading,
                      expression: "earningLoading",
                    },
                  ],
                  attrs: {
                    data: _vm.earnings,
                    border: "",
                    stripe: "",
                    "empty-text": "尚無收益記錄",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { prop: "memberName", label: "會員", width: "120" },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "opportunityTitle",
                      label: "方案",
                      "min-width": "180",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "title",
                      label: "收益標題",
                      "min-width": "160",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "金額", width: "130", align: "right" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.formatAmount(
                                    scope.row.amount,
                                    scope.row.currency
                                  )
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "收益狀態", width: "105" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              _vm._s(_vm.earningStatusLabel(scope.row.status))
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "Mock 請領", "min-width": "180" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.claim
                              ? [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.claimStatusLabel(
                                          scope.row.claim.status
                                        )
                                      ) +
                                      " "
                                  ),
                                  _c("small", { staticClass: "time-label" }, [
                                    _vm._v(_vm._s(scope.row.claim.requestedAt)),
                                  ]),
                                ]
                              : _c("span", [_vm._v("未提出")]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "completedAt",
                      label: "完成日",
                      width: "120",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "操作",
                      width: "290",
                      align: "center",
                      fixed: "right",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            ["pending", "available"].includes(scope.row.status)
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      size: "mini",
                                      disabled: _vm.featureDisabled,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.openEarningEditor(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v(" 編輯 ")]
                                )
                              : _vm._e(),
                            scope.row.claim &&
                            scope.row.claim.status === "pending"
                              ? [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        size: "mini",
                                        type: "success",
                                        disabled: _vm.featureDisabled,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.openClaimDecision(
                                            scope.row,
                                            "approved"
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v(" 核准 ")]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        size: "mini",
                                        type: "danger",
                                        disabled: _vm.featureDisabled,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.openClaimDecision(
                                            scope.row,
                                            "rejected"
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v(" 拒絕 ")]
                                  ),
                                ]
                              : _vm._e(),
                            !scope.row.claim &&
                            ["pending", "available"].includes(scope.row.status)
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      size: "mini",
                                      type: "danger",
                                      disabled: _vm.featureDisabled,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.deleteEarning(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v(" 刪除 ")]
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c("pagination", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.earningTotal > 0,
                    expression: "earningTotal > 0",
                  },
                ],
                attrs: {
                  total: _vm.earningTotal,
                  page: _vm.earningQuery.page,
                  limit: _vm.earningQuery.limit,
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(_vm.earningQuery, "page", $event)
                  },
                  "update:limit": function ($event) {
                    return _vm.$set(_vm.earningQuery, "limit", $event)
                  },
                  pagination: _vm.fetchEarnings,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.editingOpportunity.id
              ? "編輯額外收入方案"
              : "新增額外收入方案",
            visible: _vm.editorVisible,
            width: "780px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.editorVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "opportunityForm",
              attrs: {
                model: _vm.editingOpportunity,
                rules: _vm.opportunityRules,
                "label-width": "110px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "標題", prop: "title" } },
                [
                  _c("el-input", {
                    attrs: { maxlength: "120", "show-word-limit": "" },
                    model: {
                      value: _vm.editingOpportunity.title,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.editingOpportunity,
                          "title",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "editingOpportunity.title",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "合作單位", prop: "partnerName" } },
                        [
                          _c("el-input", {
                            attrs: { maxlength: "100" },
                            model: {
                              value: _vm.editingOpportunity.partnerName,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.editingOpportunity,
                                  "partnerName",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "editingOpportunity.partnerName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "分類", prop: "category" } },
                        [
                          _c("el-input", {
                            attrs: { maxlength: "50" },
                            model: {
                              value: _vm.editingOpportunity.category,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.editingOpportunity,
                                  "category",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "editingOpportunity.category",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "適用身分", prop: "eligibleRole" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              model: {
                                value: _vm.editingOpportunity.eligibleRole,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.editingOpportunity,
                                    "eligibleRole",
                                    $$v
                                  )
                                },
                                expression: "editingOpportunity.eligibleRole",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "領隊", value: "leader" },
                              }),
                              _c("el-option", {
                                attrs: { label: "導遊", value: "guide" },
                              }),
                              _c("el-option", {
                                attrs: { label: "皆可", value: "both" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "工作模式", prop: "workMode" } },
                        [
                          _c("el-input", {
                            attrs: { maxlength: "50" },
                            model: {
                              value: _vm.editingOpportunity.workMode,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.editingOpportunity,
                                  "workMode",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "editingOpportunity.workMode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "報酬說明", prop: "rewardDescription" } },
                [
                  _c("el-input", {
                    attrs: { maxlength: "200" },
                    model: {
                      value: _vm.editingOpportunity.rewardDescription,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.editingOpportunity,
                          "rewardDescription",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "editingOpportunity.rewardDescription",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "摘要", prop: "summary" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 3,
                      maxlength: "1000",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.editingOpportunity.summary,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.editingOpportunity,
                          "summary",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "editingOpportunity.summary",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "工作項目", prop: "workItems" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 3,
                      maxlength: "2000",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.editingOpportunity.workItems,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.editingOpportunity,
                          "workItems",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "editingOpportunity.workItems",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "資格要求", prop: "requirements" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 3,
                      maxlength: "2000",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.editingOpportunity.requirements,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.editingOpportunity,
                          "requirements",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "editingOpportunity.requirements",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "標籤", prop: "tags" } },
                [
                  _c("el-select", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      multiple: "",
                      filterable: "",
                      "allow-create": "",
                      "default-first-option": "",
                      "multiple-limit": 8,
                      placeholder: "最多 8 個標籤，每個最多 30 字",
                    },
                    model: {
                      value: _vm.editingOpportunity.tags,
                      callback: function ($$v) {
                        _vm.$set(_vm.editingOpportunity, "tags", $$v)
                      },
                      expression: "editingOpportunity.tags",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "名額", prop: "quota" } },
                        [
                          _c("el-input-number", {
                            attrs: { min: 0, max: 999999, precision: 0 },
                            model: {
                              value: _vm.editingOpportunity.quota,
                              callback: function ($$v) {
                                _vm.$set(_vm.editingOpportunity, "quota", $$v)
                              },
                              expression: "editingOpportunity.quota",
                            },
                          }),
                          _c("small", { staticClass: "field-hint" }, [
                            _vm._v("0 表示不限"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "截止日" } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              "value-format": "yyyy-MM-dd",
                              disabled: _vm.editingOpportunity.alwaysOpen,
                            },
                            model: {
                              value: _vm.editingOpportunity.applicationDeadline,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.editingOpportunity,
                                  "applicationDeadline",
                                  $$v
                                )
                              },
                              expression:
                                "editingOpportunity.applicationDeadline",
                            },
                          }),
                          _c(
                            "el-checkbox",
                            {
                              model: {
                                value: _vm.editingOpportunity.alwaysOpen,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.editingOpportunity,
                                    "alwaysOpen",
                                    $$v
                                  )
                                },
                                expression: "editingOpportunity.alwaysOpen",
                              },
                            },
                            [_vm._v("長期開放")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "推薦" } },
                        [
                          _c("el-switch", {
                            model: {
                              value: _vm.editingOpportunity.isRecommended,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.editingOpportunity,
                                  "isRecommended",
                                  $$v
                                )
                              },
                              expression: "editingOpportunity.isRecommended",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "推薦排序" } },
                        [
                          _c("el-input-number", {
                            attrs: { min: 0, max: 9999 },
                            model: {
                              value: _vm.editingOpportunity.recommendSort,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.editingOpportunity,
                                  "recommendSort",
                                  $$v
                                )
                              },
                              expression: "editingOpportunity.recommendSort",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.editorVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.opportunitySaving },
                  on: { click: _vm.saveOpportunity },
                },
                [_vm._v(" 儲存 ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "方案預覽",
            visible: _vm.previewVisible,
            width: "720px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.previewVisible = $event
            },
          },
        },
        [
          _vm.previewItem
            ? _c(
                "el-descriptions",
                { attrs: { column: 2, border: "" } },
                [
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "標題", span: 2 } },
                    [_vm._v(_vm._s(_vm.previewItem.title))]
                  ),
                  _c("el-descriptions-item", { attrs: { label: "合作單位" } }, [
                    _vm._v(_vm._s(_vm.previewItem.partnerName)),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "分類" } }, [
                    _vm._v(_vm._s(_vm.previewItem.category)),
                  ]),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "報酬", span: 2 } },
                    [_vm._v(_vm._s(_vm.previewItem.rewardDescription))]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "摘要", span: 2 } },
                    [_vm._v(_vm._s(_vm.previewItem.summary))]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "工作項目", span: 2 } },
                    [_vm._v(_vm._s(_vm.previewItem.workItems))]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "資格要求", span: 2 } },
                    [_vm._v(_vm._s(_vm.previewItem.requirements))]
                  ),
                  _c("el-descriptions-item", { attrs: { label: "截止日" } }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.previewItem.alwaysOpen
                            ? "長期開放"
                            : _vm.previewItem.applicationDeadline || "未設定"
                        ) +
                        " "
                    ),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "標籤" } }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          (_vm.previewItem.tags || []).join("、") || "無"
                        ) +
                        " "
                    ),
                  ]),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "申請詳情",
            visible: _vm.applicationDetailVisible,
            width: "720px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.applicationDetailVisible = $event
            },
          },
        },
        [
          _vm.applicationDetail
            ? _c(
                "el-descriptions",
                { attrs: { column: 2, border: "" } },
                [
                  _c("el-descriptions-item", { attrs: { label: "姓名" } }, [
                    _vm._v(_vm._s(_vm.applicationDetail.applicantName)),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "身分" } }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.eligibleRoleLabel(
                            _vm.applicationDetail.eligibleRole
                          )
                        ) +
                        " "
                    ),
                  ]),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "聯絡方式", span: 2 } },
                    [_vm._v(" " + _vm._s(_vm.applicationDetail.contact) + " ")]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "相關經驗", span: 2 } },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.applicationDetail.experience) + " "
                      ),
                    ]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "申請原因", span: 2 } },
                    [_vm._v(_vm._s(_vm.applicationDetail.reason))]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "可配合時間", span: 2 } },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.applicationDetail.availability) + " "
                      ),
                    ]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "作品連結", span: 2 } },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.applicationDetail.portfolioUrl || "無") +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "補充說明", span: 2 } },
                    [_vm._v(_vm._s(_vm.applicationDetail.extra))]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.editingEarning.id ? "編輯收益記錄" : "新增收益記錄",
            visible: _vm.earningEditorVisible,
            width: "720px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.earningEditorVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "earningForm",
              attrs: {
                model: _vm.editingEarning,
                rules: _vm.earningRules,
                "label-width": "110px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "合作方案", prop: "opportunityId" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        filterable: "",
                        disabled: Boolean(_vm.editingEarning.id),
                      },
                      on: { change: _vm.loadApprovedApplications },
                      model: {
                        value: _vm.editingEarning.opportunityId,
                        callback: function ($$v) {
                          _vm.$set(_vm.editingEarning, "opportunityId", $$v)
                        },
                        expression: "editingEarning.opportunityId",
                      },
                    },
                    _vm._l(_vm.opportunityOptions, function (option) {
                      return _c("el-option", {
                        key: option.id,
                        attrs: {
                          label: option.title + "｜" + option.partnerName,
                          value: option.id,
                        },
                      })
                    }),
                    1
                  ),
                  _vm.opportunityOptionsError
                    ? _c(
                        "div",
                        { staticClass: "selector-load-error" },
                        [
                          _c("el-alert", {
                            attrs: {
                              type: "error",
                              title: _vm.opportunityOptionsError,
                              closable: false,
                              "show-icon": "",
                            },
                          }),
                          _vm.opportunityOptionsRetryable
                            ? _c(
                                "el-button",
                                {
                                  attrs: { size: "mini" },
                                  on: { click: _vm.retryOpportunityOptions },
                                },
                                [_vm._v(" 重新載入方案 ")]
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              !_vm.editingEarning.id
                ? _c(
                    "el-form-item",
                    { attrs: { label: "核准申請", prop: "applicationId" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            filterable: "",
                            loading: _vm.approvedApplicationsLoading,
                          },
                          on: { change: _vm.selectEarningApplication },
                          model: {
                            value: _vm.editingEarning.applicationId,
                            callback: function ($$v) {
                              _vm.$set(_vm.editingEarning, "applicationId", $$v)
                            },
                            expression: "editingEarning.applicationId",
                          },
                        },
                        _vm._l(
                          _vm.approvedApplications,
                          function (application) {
                            return _c("el-option", {
                              key: application.id,
                              attrs: {
                                label:
                                  application.applicantName +
                                  "｜" +
                                  (application.summary || ""),
                                value: application.id,
                              },
                            })
                          }
                        ),
                        1
                      ),
                      _vm.approvedApplicationsError
                        ? _c(
                            "div",
                            { staticClass: "selector-load-error" },
                            [
                              _c("el-alert", {
                                attrs: {
                                  type: "error",
                                  title: _vm.approvedApplicationsError,
                                  closable: false,
                                  "show-icon": "",
                                },
                              }),
                              _vm.approvedApplicationsRetryable
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { size: "mini" },
                                      on: {
                                        click: _vm.retryApprovedApplications,
                                      },
                                    },
                                    [_vm._v(" 重新載入核准申請 ")]
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "會員" } },
                [
                  _c("el-input", {
                    attrs: {
                      value:
                        _vm.editingEarning.memberName ||
                        _vm.editingEarning.userId,
                      disabled: "",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "收益標題", prop: "title" } },
                [
                  _c("el-input", {
                    attrs: { maxlength: "200", "show-word-limit": "" },
                    model: {
                      value: _vm.editingEarning.title,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.editingEarning,
                          "title",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "editingEarning.title",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "金額", prop: "amount" } },
                        [
                          _c("el-input-number", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              min: 0.01,
                              max: 9999999999.99,
                              precision: 2,
                            },
                            model: {
                              value: _vm.editingEarning.amount,
                              callback: function ($$v) {
                                _vm.$set(_vm.editingEarning, "amount", $$v)
                              },
                              expression: "editingEarning.amount",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "幣別", prop: "currency" } },
                        [
                          _c("el-input", {
                            attrs: { maxlength: "3" },
                            model: {
                              value: _vm.editingEarning.currency,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.editingEarning,
                                  "currency",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "editingEarning.currency",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "收益狀態", prop: "status" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              model: {
                                value: _vm.editingEarning.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.editingEarning, "status", $$v)
                                },
                                expression: "editingEarning.status",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "待確認", value: "pending" },
                              }),
                              _c("el-option", {
                                attrs: { label: "可請領", value: "available" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "完成日", prop: "completedAt" } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              type: "date",
                              "value-format": "yyyy-MM-dd",
                            },
                            model: {
                              value: _vm.editingEarning.completedAt,
                              callback: function ($$v) {
                                _vm.$set(_vm.editingEarning, "completedAt", $$v)
                              },
                              expression: "editingEarning.completedAt",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "結算日" } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: { type: "date", "value-format": "yyyy-MM-dd" },
                    model: {
                      value: _vm.editingEarning.settlementDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.editingEarning, "settlementDate", $$v)
                      },
                      expression: "editingEarning.settlementDate",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "說明" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 3,
                      maxlength: "1000",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.editingEarning.description,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.editingEarning,
                          "description",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "editingEarning.description",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.earningEditorVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.earningSaving },
                  on: { click: _vm.saveEarning },
                },
                [_vm._v("儲存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title:
              _vm.claimDecision.status === "approved"
                ? "核准 Mock 請領"
                : "拒絕 Mock 請領",
            visible: _vm.claimDecision.visible,
            width: "520px",
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.claimDecision, "visible", $event)
            },
          },
        },
        [
          _c("el-alert", {
            attrs: {
              title: "此操作只會記錄 Mock 狀態與稽核資訊，不會執行真實撥款。",
              type: "warning",
              closable: false,
              "show-icon": "",
            },
          }),
          _c(
            "el-form",
            { staticClass: "claim-form", attrs: { "label-width": "80px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "處理說明" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 4,
                      maxlength: "500",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.claimDecision.note,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.claimDecision,
                          "note",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "claimDecision.note",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.claimDecision.visible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.claimDecision.saving },
                  on: { click: _vm.submitClaimDecision },
                },
                [_vm._v(" 確認 ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("h2", [_vm._v("額外收入管理")]),
      _c("p", [_vm._v("管理合作方案、正式申請、收益與 Mock 請領狀態。")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }